import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { PlacaService } from "../../services/placa.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { ListValueService } from "src/app/core/services/list-value.service";
import { TokenService } from "src/app/core/services/token.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { StatesComponent } from "src/app/shared/states/states.component";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { StatesPetitionsService } from "src/app/core/services/states-petitions.service";
import { RoutingStatesService } from "src/app/core/services/routingStates.service";
import { AppConstants } from "src/app/constants/app.constants";
import { CommonService } from "src/app/core/services/common.service";
import { TranslateService } from "@ngx-translate/core";
import {
  dynamicsFields,
  camposdisponibles,
} from "src/app/coc/models/dynamicsFields";
import { DynamicFieldsComponent } from "src/app/shared/dynamic-fields/dynamic-fields.component";
import { ListRelatedRequests } from "src/app/shared/models/listRelatedRequest";
import { RoutingStates } from "src/app/core/models/routingStates";
import { TableConstants } from "src/app/constants/tableConstants";
import { CreateImgPlacaRequest, ImgPlacaRequest } from "../../models/imgPlaca";
import { CommentsHistoryPeticionComponent } from "src/app/shared/comments-history-peticion/comments-history-peticion.component";
import {
  FieldBase,
  InputTextField,
  ShowField,
  TextareaField,
} from "src/app/shared/form-fields/model";
import * as moment from "moment";
import { FormFieldsComponent } from "src/app/shared/form-fields/form-fields.component";
import { SelectorWithSearchField } from "src/app/shared/form-fields/model/selector-with-search-field.model";

@Component({
  selector: "app-detail-mailbox",
  templateUrl: "./detail-mailbox.component.html",
  styleUrls: ["./detail-mailbox.component.scss"],
})
export class DetailMailboxComponent implements OnInit {
  public roles = AppConstants.roles;
  public fieldsSolicitud: FieldBase<any>[];
  public fieldsVehiculo: FieldBase<any>[];
  public fieldsComentario: FieldBase<any>[];

  @ViewChild("vehiculo") vehiculoFields: FormFieldsComponent;
  @ViewChild("solicitud") solicitudFields: FormFieldsComponent;
  @ViewChild("comentario") comentarioFields: FormFieldsComponent;

  placa = {
    data: {
      peticion: null,
      hdetallePeticions: null,
      detallePeticiones: null,
    },
    loaded: false,
  };
  fields = {
    list: [],
    loaded: false,
  };
  sectionHidden = {
    peticion: false,
    vehiculo: false,
    placa: false,
    obs: false,
    correction: false,
  };
  formLoaded: boolean = false;
  etiquetas;
  etiquetaSelectedInitial: string;
  etiquetaSelected: string;
  routing = RoutingConstants.placaMailBox;
  castDynamicsFields = AppConstants.castDynamicsFields;
  fieldsCasted: dynamicsFields[];
  fieldsCastedAux: dynamicsFields[] = [];
  id: string;
  type: string;
  commentsHistory = {
    opened: false,
    loaded: false,
    data: [],
  };
  etiquetaAndHomologado;
  placaData = new FormGroup({});
  operation: string;
  userIdConected: string;
  imgPlaca: ImgPlacaRequest;
  @ViewChild("states") states: StatesComponent;
  @ViewChild("dynamicFields") dynamicFields: DynamicFieldsComponent;
  @ViewChild(CommentsHistoryPeticionComponent)
  commentsHistoryComponent: CommentsHistoryPeticionComponent;

  config: ListRelatedRequests;
  routingStates: RoutingStates;
  brandsList = [];

  constructor(
    private mailboxPlacaService: PlacaService,
    private toastrAlertService: ToastrAlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private listValueService: ListValueService,
    private tokenService: TokenService,
    private translateService: TranslateService,
    private sweetAlertService: SweetAlertService,
    private statesPetitionsService: StatesPetitionsService,
    private routingStatesService: RoutingStatesService,
    private commonService: CommonService
  ) {
    this.userIdConected = this.tokenService.getUserName();
    this.config = {
      type: "PLACA",
      bastidor: "",
      title: "Más placas",
      opened: false,
      tableContasts: TableConstants.placaQuery,
      optionsTable:
        TableConstants.NotShowCreateDeleteAndArrowUpDownFiltersButtonAndShowLabel,
      routingTableEnTramite: RoutingConstants.placaQuery,
      routingTableHistory: RoutingConstants.placaQueryHistory,
    };
  }

  ngOnInit(): void {
    this.getBrands();
    this.activatedRoute.params.subscribe((data) => {
      this.init();
    });
  }

  init() {
    this.routingStates = this.routingStatesService.getRoutingStates();
    this.id = this.activatedRoute.snapshot.params.id;
    this.operation = this.activatedRoute.data["_value"]["operation"];
    this.type = this.activatedRoute.data["_value"]["type"];
    this.placa.loaded = false;
    this.getEtiquetas();
    if (this.type == "history") {
      this.getHistoryQueryPlaca();
    } else if (this.type == "NotHistory") {
      this.getQueryDetail();
    } else {
      this.getPlacaMailbox();
    }
    this.getPrintFields();
  }

  getHistoryQueryPlaca() {
    this.mailboxPlacaService.getHistoryDetail(this.id).subscribe(
      (data) => {
        this.config.bastidor = data.peticion.peBastidor;
        this.placa.data = data;
        this.placa.data.peticion.usuario2 = this.placa.data.peticion.usuario2
          ? this.placa.data.peticion.usuario2
          : { usNombre: "" };
        this.etiquetaAndHomologado = this.getInitTipoEtiquetaAndTipoHomologado(
          this.placa.data.detallePeticiones
        );
        this.etiquetaSelected = this.etiquetaAndHomologado.tipoEtiqueta;
        this.etiquetaSelectedInitial = this.etiquetaSelected;
        this.placa.data.peticion.imgNueva =
          this.placa.data.detallePeticiones.find(
            (e) => e.id.dpCampo == "ImagenNueva"
          )?.dpValor;
        this.placa.loaded = true;
        this.fieldsCasted = this.castingDynamicFieldsForPlaca(
          this.castDynamicsFields,
          data.detallePeticiones
        );
        this.getImgPlaca();
        this.initFields();
        if (this.fields.loaded) {
          this.initForm(this.placa.data.detallePeticiones);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getQueryDetail() {
    this.mailboxPlacaService.getDetailQuery(this.id).subscribe(
      (data) => {
        this.config.bastidor = data.peticion.peBastidor;
        this.placa.data = data;
        this.placa.data.peticion.usuario2 = this.placa.data.peticion.usuario2
          ? this.placa.data.peticion.usuario2
          : { usNombre: "" };
        this.etiquetaAndHomologado = this.getInitTipoEtiquetaAndTipoHomologado(
          this.placa.data.detallePeticiones
        );
        this.etiquetaSelected = this.etiquetaAndHomologado.tipoEtiqueta;
        this.etiquetaSelectedInitial = this.etiquetaSelected;
        this.placa.data.peticion.imgNueva =
          this.placa.data.detallePeticiones.find(
            (e) => e.id.dpCampo == "ImagenNueva"
          )?.dpValor;
        this.placa.loaded = true;
        this.fieldsCasted = this.castingDynamicFieldsForPlaca(
          this.castDynamicsFields,
          data.detallePeticiones
        );
        this.getImgPlaca();
        this.initFields();
        if (this.fields.loaded) {
          this.initForm(this.placa.data.detallePeticiones);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getPlacaMailbox() {
    this.mailboxPlacaService.getPlaca(this.id).subscribe(
      (data) => {
        this.config.bastidor = data.peticion.peBastidor;
        this.placa.data = data;
        this.placa.data.peticion.usuario2 = this.placa.data.peticion.usuario2
          ? this.placa.data.peticion.usuario2
          : { usNombre: "" };
        this.etiquetaAndHomologado = this.getInitTipoEtiquetaAndTipoHomologado(
          this.placa.data.detallePeticiones
        );
        this.etiquetaSelected = this.etiquetaAndHomologado.tipoEtiqueta;
        this.etiquetaSelectedInitial = this.etiquetaSelected;
        this.placa.data.peticion.imgNueva =
          this.placa.data.detallePeticiones.find(
            (e) => e.id.dpCampo == "ImagenNueva"
          )?.dpValor;
        this.placa.loaded = true;
        this.fieldsCasted = this.castingDynamicFieldsForPlaca(
          this.castDynamicsFields,
          data.detallePeticiones
        );
        this.getImgPlaca();
        this.initFields();
        if (this.fields.loaded) {
          this.initForm(this.placa.data.detallePeticiones);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getPrintFields() {
    this.mailboxPlacaService.getPrintFields().subscribe(
      (data) => {
        this.fields.list = data;
        this.fields.loaded = true;
        if (this.placa.loaded) {
          this.initForm(this.placa.data.detallePeticiones);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getEtiquetas() {
    this.listValueService.listValuesEtiqueta().subscribe(
      (data) => {
        this.etiquetas = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  initForm(detallePeticiones: any[]): void {
    this.placaData = new FormGroup({});
    this.fields.list.forEach((element) => {
      let value = detallePeticiones.find((e) => e?.id?.dpCampo == element.ciId);
      if (this.isPosibleChangeData()) {
        if (value) {
          this.placaData.addControl(
            element.ciId,
            new FormControl(value.dpValor)
          );
        } else {
          this.placaData.addControl(element.ciId, new FormControl(""));
        }
      } else {
        if (value) {
          const dpValor = value.dpValor;
          this.placaData.addControl(
            element.ciId,
            new FormControl({ value: dpValor, disabled: true })
          );
        } else {
          this.placaData.addControl(
            element.ciId,
            new FormControl({ value: "", disabled: true })
          );
        }
      }
    });
    this.formLoaded = true;
  }

  goList() {
    if (this.routingStates) {
      this.router.navigate([
        this.routingStates.urlBefore,
        this.routingStates.urlBeforeId,
      ]);
    } else if (this.activatedRoute.data["_value"]["url"] == "consulta") {
      this.router.navigate([RoutingConstants.placaQuery.list]);
    } else {
      this.router.navigate([this.routing.list]);
    }
  }

  async onSave() {
    let result = this.formatToSave();
    this.sweetAlertService.sweetAlertLoading();
    this.mailboxPlacaService.savePlacaData(result).subscribe(
      (data) => {
        if (data.validacion) {
          this.toastrAlertService.toastrSuccess(
            "La placa se ha editado correctamente"
          );
          this.sweetAlertService.sweetAlertClose();
          this.placaData = new FormGroup({});
          if (this.type == "history") {
            this.getHistoryQueryPlaca();
          } else if (this.type == "NotHistory") {
            this.getQueryDetail();
          } else {
            this.getPlacaMailbox();
          }
        } else {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(data.textoValidacion);
        }
      },
      (err) => {
        this.sweetAlertService.sweetAlertClose();
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  formatToSave(): any {
    let result: any;
    let peticioneList = [];
    Object.keys(this.placaData.value).forEach((key) => {
      let peticione = {
        dpCampoid: "",
        dpCampo: key,
        dpValor: this.placaData.value[key],
        dpFichero: "",
        dpDocumentacion: "",
        dpId: this.id,
        dpRelease: this.placa.data.peticion.id.peRelease,
      };
      peticioneList.push(peticione);
    });
    if (this.activatedRoute.data["_value"]["type"] == "history") {
      this.etiquetaAndHomologado = this.getTipoEtiquetaAndTipoHomologado(
        this.placa.data.hdetallePeticions
      );
    } else {
      this.etiquetaAndHomologado = this.getTipoEtiquetaAndTipoHomologado(
        this.placa.data.detallePeticiones
      );
    }

    result = {
      marca: this.placa.data.peticion.marca.maId,
      tipoEtiqueta: this.etiquetaSelected,
      //tipoEtiqueta: "F",
      tipoPlaca: "",
      tipoHomologado: this.etiquetaAndHomologado.tipoHomologado,
      //tipoHomologado: "5F",
      detallePeticionesList: peticioneList,
      textoValidacion: "",
      validacion: true,
    };
    return result;
  }

  getInitTipoEtiquetaAndTipoHomologado(detallePeticiones: any[]): any {
    let tipoEtiqueta;
    detallePeticiones.forEach((element) => {
      if (element.id && element.id.dpCampo == "TipoEtiqueta") {
        tipoEtiqueta = element.dpValor;
      }
    });
    return { tipoEtiqueta: tipoEtiqueta };
  }

  getTipoEtiquetaAndTipoHomologado(detallePeticiones: any[]): any {
    let tipoHomologado;
    let tipoEtiqueta;
    detallePeticiones.forEach((element) => {
      if (element.id && this.placaData.value[element.id.dpCampo] == "TIPO") {
        tipoHomologado = element.dpValor;
      } else if (
        element.id &&
        this.placaData.value[element.id.dpCampo] == "TipoEtiqueta"
      ) {
        tipoEtiqueta = element.dpValor;
      }
    });
    return { tipoHomologado: tipoHomologado, tipoEtiqueta: tipoEtiqueta };
  }

  async savePlacaData() {
    return new Promise((resolve, reject) => {
      this.sweetAlertService.sweetAlertLoading();
      this.mailboxPlacaService.savePlacaData(this.formatToSave()).subscribe(
        (data) => {
          this.sweetAlertService.sweetAlertClose();
          resolve(data);
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
          reject(err);
        }
      );
    });
  }

  async reloadDetail(state: string) {
    this.commentsHistoryComponent.commentsHistory.loaded = false;
    if (state == "FG" || state == "EF") {
      this.router.navigate([RoutingConstants.placaQueryHistory.edit, this.id]);
    } else if (state == "RE" || state == "PF" || state == "FI") {
      if (this.router.url.startsWith(RoutingConstants.placaQuery.edit)) {
        this.router.navigate([RoutingConstants.placaQuery.list]);
      } else {
        this.router.navigate([RoutingConstants.placaMailBox.list]);
      }
    } else if (state == "PA") {
      if (this.type != "history") {
        this.init();
      } else if (this.router.url.startsWith(RoutingConstants.placaQuery.edit)) {
        this.router.navigate([RoutingConstants.placaQuery.edit, this.id]);
      } else {
        this.router.navigate([RoutingConstants.placaMailBox.edit, this.id]);
      }
    } else if (state == "PF-Placa") {
      await this.savePlacaData();
      this.states.changeStatetoPFPlaca(this.formatToSave());
    } else {
      if (this.type != "history" && this.type != "NotHistory") {
        this.init();
      }
      if ((this.type = "NotHistory")) {
        this.init();
      } else {
        this.router.navigate([RoutingConstants.placaQuery.edit, this.id]);
      }
    }
  }
  reasgine(value: string) {
    this.init();
  }

  formatToCorrect(array: dynamicsFields[]): dynamicsFields[] {
    array.forEach((e) => {
      let pos: number = this.castDynamicsFields.findIndex(
        (element) => element.text == e.dpCampo
      );
      if (pos > -1) {
        e.dpCampo = this.castDynamicsFields[pos].id;
        switch (this.castDynamicsFields[pos].type) {
          case "DBLIST":
            if (e.dpValor != null) {
              e.dpValor = e.dpValor["valor"];
            }
            break;

          case "STRING":
            //nothing to do
            break;

          case "FILE":
            let fileIndex: number = this.dynamicFields.files.findIndex(
              (file) => file.name == e.dpFichero
            );
            if (fileIndex > -1) {
              e.dpValor = fileIndex.toString();
            } else {
              e.dpValor = null;
            }
            break;
          default:
            break;
        }
      }
    });
    return array;
  }

  public getOthersFields(): dynamicsFields[] {
    let resultArray: dynamicsFields[] = [];
    this.placa.data.detallePeticiones.forEach((e) => {
      let pos: number = this.castDynamicsFields.findIndex(
        (element) => element.id == e.id.dpCampo
      );
      if (pos == -1) {
        let object: dynamicsFields = {
          camposdisponibles: null,
          dpCampo: e?.id?.dpCampo,
          dpCampoid: e.dpCampoid,
          dpDocumentacion: e?.dpDocumentacion,
          dpFichero: e.dpFichero,
          dpId: e?.id?.dpId,
          dpRelease: e?.id?.dpRelease,
          dpValor: e.dpValor,
        };
        resultArray.push(object);
      }
    });

    return resultArray;
  }

  onCorrect(): void {
    let fieldsAux = this.cloneObject(this.dynamicFields.fields);
    fieldsAux = this.formatToCorrect(fieldsAux);
    let formComentario = this.comentarioFields.getForm();
    let formVehiculo = this.vehiculoFields.getForm();
    if (formVehiculo && formComentario) {
      if (
        formVehiculo.value.bastidor === this.placa?.data?.peticion?.peBastidor
      ) {
        fieldsAux = [...fieldsAux, ...this.getOthersFields()];
      }
      let object = {
        peId: this.placa.data.peticion.id.peId,
        peRelease: this.placa.data.peticion.id.peRelease,
        peMatricula: "",
        peBastidor: formVehiculo.value.bastidor,
        peMarca: formVehiculo.value.marca,
        peComentarios: formComentario.value.nuevoComentario,
        detallepeticiones: fieldsAux,
        files: null,
      };
      this.sweetAlertService.sweetAlertLoading();
      this.mailboxPlacaService
        .correctPlaca(object, this.dynamicFields.files)
        .subscribe(
          (data) => {
            this.toastrAlertService.toastrSuccess(data.mensaje);
            this.commentsHistoryComponent.commentsHistory.loaded = false;
            this.sweetAlertService.sweetAlertClose();
            this.init();
          },
          (err) => {
            this.toastrAlertService.toastrFail(err.error.mensaje);
            this.sweetAlertService.sweetAlertClose();
          }
        );
    }
  }

  goEdit() {
    this.operation = "edit";
    this.fieldsCastedAux = this.cloneObject(this.fieldsCasted);
    this.initFields();
    this.dynamicFields.getDynamicDBLists();
  }

  goDetail(type?: string) {
    this.operation = "detail";
    this.fieldsCasted = this.cloneObject(this.fieldsCastedAux);
    this.initFields();
  }

  cloneObject(array: dynamicsFields[]) {
    let arrayAux: dynamicsFields[] = [];
    array.forEach((e) => {
      let object: dynamicsFields = {
        camposdisponibles: e.camposdisponibles,
        dpCampo: e.dpCampo,
        dpCampoid: e.dpCampoid,
        dpDocumentacion: e.dpDocumentacion,
        dpFichero: e.dpFichero,
        dpId: e.dpId,
        dpRelease: e.dpRelease,
        dpValor: e.dpValor,
      };
      arrayAux.push(object);
    });
    return arrayAux;
  }

  castingDynamicFieldsForPlaca(
    castDynamicsFields: any,
    detallepeticiones: any[]
  ): dynamicsFields[] {
    let tcertificado = this.placa?.data?.peticion?.tcertificado?.tcId;
    let dynamicsFieldsCasted: dynamicsFields[] = [];
    castDynamicsFields.forEach((element) => {
      let index =
        element.id == "FicheroAdjunto" && tcertificado == "PLI"
          ? -1
          : detallepeticiones.findIndex((e) => e.id.dpCampo == element.id);
      if (index > -1) {
        let camposdisponibles: camposdisponibles = {
          ccObligatorio: null,
          cdId: null,
          cdListadb: element.list ? element.list : null,
          cdLongitud: null,
          cdTexto: null,
          cdTipo: element.type,
        };
        let object: dynamicsFields = {
          dpCampo: element.text,
          dpCampoid: detallepeticiones[index].dpCampoid,
          dpDocumentacion: detallepeticiones[index].dpDocumentacion,
          dpFichero: detallepeticiones[index].dpFichero,
          dpId: detallepeticiones[index].id.dpId,
          dpRelease: detallepeticiones[index].id.dpRelease,
          dpValor: detallepeticiones[index].dpValor,
          camposdisponibles: camposdisponibles,
        };
        dynamicsFieldsCasted.push(object);
      }
    });
    return dynamicsFieldsCasted;
  }

  refresh() {
    this.sweetAlertService.sweetAlertLoading();
    this.mailboxPlacaService
      .updatedDatosPlaca(
        this.placa.data.peticion.id.peId,
        this.placa.data.peticion.id.peRelease
      )
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          if (this.type == "history") {
            this.getHistoryQueryPlaca();
          } else if (this.type == "NotHistory") {
            this.getQueryDetail();
          } else {
            this.getPlacaMailbox();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  downloadFile(field: any) {
    this.sweetAlertService.sweetAlertLoading();
    let object = this.castDynamicsFields.find((e) => e.text == field.dpCampo);
    this.commonService
      .getFilesOfDetallePeticiones(
        object.id,
        field.dpId,
        field.dpRelease,
        this.type == "history" ? "true" : "false"
      )
      .subscribe(
        (data) => {
          this.commonService.downloadFile(data, field.dpFichero);
          this.sweetAlertService.sweetAlertClose();
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
  }

  getImgPlaca() {
    this.imgPlaca = {
      idPeticion: this.placa?.data?.peticion?.id?.peId,
      release: this.placa?.data?.peticion?.id?.peRelease,
      codImagenNueva: "",
      codImagenAntigua: this.placa.data.detallePeticiones.find(
        (e) => e.id.dpCampo == "ImagenAnterior"
      )?.dpValor,
    };
  }

  asingImgPlaca() {
    if (this.imgPlaca.codImagenNueva != "") {
      this.sweetAlertService.sweetAlertLoading();
      this.mailboxPlacaService.assignImagePlaca(this.imgPlaca).subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          if (this.type == "history") {
            this.getHistoryQueryPlaca();
          } else if (this.type == "NotHistory") {
            this.getQueryDetail();
          } else {
            this.getPlacaMailbox();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
    } else {
      let message = this.translateService.instant(
        "messages.placa.codPlacaRequired"
      );
      this.toastrAlertService.toastrFail(message);
    }
  }

  getHisoricoBastidor() {
    this.sweetAlertService.sweetAlertLoading();
    this.mailboxPlacaService.getHistoricoBastidor(this.placa.data.peticion.peBastidor).subscribe(
      (data) => {

        if(data.hbCodimag == null || data.hbCodimag == "" || data.hbCodimag == "-") 
        {
          this.toastrAlertService.toastrFail("El bastidor no tiene informada la imagen");
          this.sweetAlertService.sweetAlertClose();
        }
        else
        {
          let imgPlacaReq: ImgPlacaRequest = {
            codImagenNueva: "",
            codImagenAntigua: data.hbCodimag,
            idPeticion: this.placa.data.peticion.id.peId,
            release: this.placa.data.peticion.id.peRelease,
          };
          this.copyImgPlaca(imgPlacaReq);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  copyImgPlaca(imgPlaca: ImgPlacaRequest) {
    this.sweetAlertService.sweetAlertLoading();
    this.mailboxPlacaService.copyImagePlaca(imgPlaca).subscribe(
      (data) => {
        if (this.type == "history") {
          this.getHistoryQueryPlaca();
        } else if (this.type == "NotHistory") {
          this.getQueryDetail();
        } else {
          this.getPlacaMailbox();
        }
        this.toastrAlertService.toastrSuccess(data.mensaje);
        this.sweetAlertService.sweetAlertClose();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
        this.sweetAlertService.sweetAlertClose();
      }
    );
  }

  createImgPlaca() {
    if (this.imgPlaca.codImagenNueva != "") {
      let peticioneList = [];
      Object.keys(this.placaData.value).forEach((key) => {
        let peticione = {
          dpCampoid: "",
          dpCampo: key,
          dpValor: this.placaData.value[key],
          dpFichero: "",
          dpDocumentacion: "",
          dpId: this.id,
          dpRelease: this.placa.data.peticion.id.peRelease,
        };
        peticioneList.push(peticione);
      });
      let imgPlacaDto: CreateImgPlacaRequest = {
        idPeticion: this.placa?.data?.peticion?.id?.peId,
        release: this.placa?.data?.peticion?.id?.peRelease,
        codImagenNueva: this.imgPlaca.codImagenNueva,
        detallePeticionesList: peticioneList,
      };
      this.sweetAlertService.sweetAlertLoading();
      this.mailboxPlacaService.createImagePlaca(imgPlacaDto).subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.sweetAlertService.sweetAlertClose();
          if (this.type == "history") {
            this.getHistoryQueryPlaca();
          } else if (this.type == "NotHistory") {
            this.getQueryDetail();
          } else {
            this.getPlacaMailbox();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
          this.sweetAlertService.sweetAlertClose();
        }
      );
    } else {
      let message = this.translateService.instant(
        "messages.placa.codPlacaRequired"
      );
      this.toastrAlertService.toastrFail(message);
    }
  }

  public isRHomologOrRevi(): boolean {
    if (
      this.tokenService.hasRole(this.roles.RHOMOLOG) ||
      this.tokenService.hasRole(this.roles.REVISOR)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalist(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.ABASICO) ||
      this.tokenService.hasRole(this.roles.AAVANZA)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalistNoBasic(): boolean {
    if (
      this.tokenService.hasRole(this.roles.ANALISTA) ||
      this.tokenService.hasRole(this.roles.AAVANZA)
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isAdmin(): boolean {
    if (this.tokenService.hasRole(this.roles.ADMIN)) {
      return true;
    } else {
      return false;
    }
  }

  public isAnalistaTramitante(): boolean {
    return this.userIdConected === this.placa?.data?.peticion?.usuario1.usId;
  }

  public isPrecioEdit(): boolean {
    return (
      this.operation == "detail" &&
      this.placa &&
      (this.placa?.data?.peticion?.estado?.esId == "PA" ||
        (this.placa?.data?.peticion?.estado?.esId == "AN" &&
          this.isAnalistaTramitante())) &&
      this.isAnalistNoBasic()
    );
  }

  onSavePrecio() {
    if (this.solicitudFields.getForm() != null) {
      let nuevoPrecio = this.solicitudFields.getForm().value.precio;
      nuevoPrecio = nuevoPrecio.replace(/[,]/g, ".");
      let id =
        this.placa?.data?.peticion?.id?.peId == undefined
          ? this.placa?.data?.peticion?.id?.id
          : this.placa?.data?.peticion?.id?.peId;

      this.sweetAlertService.sweetAlertLoading();
      this.mailboxPlacaService.editarPrecio(id, nuevoPrecio).subscribe(
        (data) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrSuccess(data.mensaje);
          this.init();
        },
        (err) => {
          this.sweetAlertService.sweetAlertClose();
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
    }
  }

  private initFields(): void {
    let id =
      this.placa?.data?.peticion?.id?.peId == undefined
        ? this.placa?.data?.peticion?.id?.id
        : this.placa?.data?.peticion?.id?.peId;
    this.fieldsSolicitud = [
      new ShowField({
        label: "ID",
        value: id,
      }),
      new ShowField({
        label: "Tipo certificado",
        value:
          this.placa?.data?.peticion?.tcertificado?.tcId +
          "-" +
          this.placa?.data?.peticion?.tcertificado?.tcDescr,
      }),
      new ShowField({
        label: "Imagen actual",
        value: this.placa?.data?.peticion?.imgNueva,
      }),
      new ShowField({
        label: "Fecha solicitud",
        value: this.placa?.data?.peticion?.peCreacion
          ? moment(this.placa?.data?.peticion?.peCreacion).format("DD/MM/yyyy")
          : "",
      }),
      new ShowField({
        label: "Hora solicitud",
        value: this.placa?.data?.peticion?.peCreacion
          ? moment(this.placa?.data?.peticion?.peCreacion).format("HH:mm:ss")
          : "",
      }),
      new ShowField({
        label: "Concesionario",
        value: this.placa?.data?.peticion?.peCpeticionario,
      }),
      new ShowField({
        label: "Usuario",
        value:
          this.placa?.data?.peticion?.usuario1?.usId +
          "-" +
          this.placa?.data?.peticion?.usuario1?.usNombre +
          " " +
          (this.placa?.data?.peticion?.usuario1?.usApellido1
            ? this.placa?.data?.peticion?.usuario1?.usApellido1
            : "") +
          " " +
          (this.placa?.data?.peticion?.usuario1?.usApellido2
            ? this.placa?.data?.peticion?.usuario1?.usApellido2
            : ""),
      }),
      new ShowField({
        label: "Teléfono",
        value: this.placa?.data?.peticion?.usuario1?.usTelefono,
      }),
      new ShowField({
        label: "Estado",
        value: this.placa?.data?.peticion?.estado?.esId,
      }),
      new ShowField({
        label: "Fecha tramitación",
        value: this.placa?.data?.peticion?.peEntrega
          ? moment(this.placa?.data?.peticion?.peEntrega).format("DD/MM/yyyy")
          : "",
      }),
      new ShowField({
        label: "Fecha facturación",
        value: this.placa?.data?.peticion?.peFactura
          ? moment(this.placa?.data?.peticion?.peFactura).format("DD/MM/yyyy")
          : "",
      }),
    ];
    if (this.isRHomologOrRevi() || this.isAnalistNoBasic() || this.isAdmin()) {
      if (/^\d+\.\d$/.test(this.placa?.data?.peticion?.pePrecio)) {
        this.placa.data.peticion.pePrecio += "0";
      }
      let precio: string = "" + this.placa.data.peticion.pePrecio;
      precio = precio.replace(/\./g, ",");
      this.fieldsSolicitud.push(
        new InputTextField({
          label: "Precio (€)",
          value: precio,
          formControlName: "precio",
          required: true,
          onlyShow: !(
            (this.placa?.data?.peticion?.estado?.esId == "PA" ||
              (this.placa?.data?.peticion?.estado?.esId == "AN" &&
                this.isAnalistaTramitante())) &&
            this.isAnalistNoBasic()
          ),
          validators: [Validators.pattern(/^[0-9]{1,5}([,][0-9]{1,2})?$/)],
        })
      );
    }
    this.fieldsVehiculo = [
      new InputTextField({
        label: "Número de bastidor",
        value: this.placa?.data?.peticion?.peBastidor,
        formControlName: "bastidor",
        onlyShow: this.operation != "edit",
        required: true,
      }),
      new ShowField({
        label: "Código VIN",
        value: this.getCodigoVin(),
      }),
      new ShowField({
        label: "Contraseña",
        value: this.placa?.data?.peticion?.pePassword,
      }),
      new SelectorWithSearchField({
        label: "Marca",
        value: this.placa?.data?.peticion?.marca?.maId,
        selectorList: this.brandsList,
        selectorFields: ["maId", "maDescr"],
        selectorId: "maId",
        selectorItem: this.brandsList.find(
          (item) => item.maId == this.placa?.data?.peticion?.marca?.maId
        ),
        selectorSendValue: (event) => {
          this.valueSelectorMarca(event);
        },
        formControlName: "marca",
        onlyShow:
          this.operation != "edit" ||
          this.tokenService.hasRole(this.roles.CONCES),
      }),
      new ShowField({
        label: "Denominación comercial",
        value: this.placa?.data?.peticion?.peDenominacion,
      }),
      new ShowField({
        label: "Código motor",
        value: this.getCodigoMotor(),
      }),
      new ShowField({
        label: "Tipo de cambio",
        value: this.getTipoCambio(),
      }),
    ];

    if (this.placa?.data?.peticion?.tcertificado?.tcId.includes("PLI")) {
      this.fieldsVehiculo.push(
        new ShowField({
          label: "Importador",
          value: this.getFieldOfDetallePeticiones("CodigoImportador"),
        })
      );
      this.fieldsVehiculo.push(
        new ShowField({
          label: "País",
          value: this.placa?.data?.peticion?.pais,
        })
      );
    }

    if (this.operation == "edit") {
      this.fieldsComentario = [
        new TextareaField({
          label: "Último Comentario",
          value: this.placa?.data?.peticion?.peComentarios,
          formControlName: "comentario",
          style: { "min-height": "50px" },
          onlyShow: true,
        }),
        new TextareaField({
          label: "Nuevo comentario",
          value: "",
          formControlName: "nuevoComentario",
          style: { "min-height": "100px" },
          required: true,
        }),
        new ShowField({
          label: "Observaciones",
          value: this.placa?.data?.peticion?.peObservaciones,
          style: { "min-height": "50px" },
        }),
      ];
    } else {
      this.fieldsComentario = [
        new TextareaField({
          label: "Comentario",
          value: this.placa?.data?.peticion?.peComentarios,
          formControlName: "comentario",
          style: { "min-height": "50px" },
          onlyShow: true,
        }),
        new TextareaField({
          label: "Nuevo comentario",
          value: "",
          formControlName: "nuevoComentario",
          style: { height: "100px" },
          hide: true,
          required: true,
        }),
        new ShowField({
          label: "Observaciones",
          value: this.placa?.data?.peticion?.peObservaciones,
          style: { "min-height": "50px" },
        }),
      ];
    }
  }

  private getCodigoVin(): string {
    if (
      this.placa?.data?.peticion?.peTipoh != null &&
      this.placa?.data?.peticion?.peTipoh != ""
    ) {
      return this.placa?.data?.peticion?.peTipoh;
    }
    return this.placa?.data?.peticion?.peTipov;
  }

  private getCodigoMotor(): string {
    let tcertificado = this.placa?.data?.peticion?.tcertificado?.tcId;
    if (tcertificado == "PLH" || tcertificado == "PLI") {
      return this.getFieldOfDetallePeticiones("TipoMotor");
    }
    return this.placa?.data?.peticion?.tmotor?.tmId;
  }

  private getTipoCambio(): string {
    let tcambio: any = this.getFieldOfDetallePeticiones("TipoCambio");
    if (tcambio != null) {
      return tcambio;
    }
    tcambio = this.placa?.data?.peticion?.tcambio;
    if (tcambio != null) {
      if (tcambio.tcDescr != null) {
        return tcambio.tcDescr;
      }
      return tcambio.tcTipo;
    }
    return "";
  }

  private getFieldOfDetallePeticiones(field: string): string {
    let valor = "";
    if (this.placa && this.placa.data && this.placa.data.detallePeticiones) {
      let item = this.placa.data.detallePeticiones.find(
        (item) => item.id.dpCampo == field
      );
      if (item != null) {
        valor = item.dpValor;
        if (item.dpDescripcion != null) {
          valor = item.dpDescripcion;
        }
      }
    }
    return valor;
  }

  preventEnter(e) {
    if (e.which == "13") {
      e.preventDefault();
    }
  }

  public isPosibleChangeData(): boolean {
    let states = "PF, FG, RE, EF";
    if (states.includes(this.placa?.data?.peticion?.estado?.esId)) {
      return false;
    } else {
      return true;
    }
  }

  async getBrands() {
    await this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        this.brandsList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  valueSelectorMarca(event: any) {
    if (event.item != undefined) {
      this.placa.data.peticion.marca.maId = event.item[event.id];
    }
  }
}
